import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
  ButtonModule,
  DIALOG_DATA,
  DialogRef,
  IconModule,
  RadioOptionModule,
  SelectModule,
  SimpleInputModule,
  TextAreaComponentModule,
} from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { EXCHANGE_API, ExchangeApiMockService } from '@kr/components/exchange/api';
import { ExchangeApiService } from '@kr/components/exchange/api/exchange-api.service';
import { CryptoCryptoFlowComponent } from '@kr/components/exchange/components/crypto-crypto-flow/crypto-crypto-flow.component';
import { CryptoFiatFlowComponent } from '@kr/components/exchange/components/crypto-fiat-flow/crypto-fiat-flow.component';
import { ExchangeStore } from '@kr/components/exchange/exchange.store';
import { environment } from '@kr/environment';
import { WalletCard } from '@kr/models';

type TransferTabs = 'crypto-crypto' | 'crypto-fiat';

@Component({
  imports: [
    TranslateModule,
    IconModule,
    ButtonModule,
    ReactiveFormsModule,
    SimpleInputModule,
    TextAreaComponentModule,
    SelectModule,
    RadioOptionModule,
    CryptoCryptoFlowComponent,
    CryptoFiatFlowComponent,
  ],
  providers: [
    ExchangeStore,
    {
      provide: EXCHANGE_API,
      useClass: environment.useMocks ? ExchangeApiMockService : ExchangeApiService,
    },
  ],
  selector: 'kr-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExchangeComponent {
  readonly #store = inject(ExchangeStore);
  tab: TransferTabs = 'crypto-crypto';
  readonly dialogRef = inject(DialogRef);
  readonly data = inject<{ wallet: WalletCard; wallets: Signal<WalletCard[]> }>(DIALOG_DATA);

  wallet: WalletCard = this.data.wallet;
  wallets: Signal<WalletCard[]> = this.data.wallets;

  setTab(tab: TransferTabs): void {
    this.tab = tab;
  }
}
